import { render, staticRenderFns } from "./CASEAssociatedItemTree.vue?vue&type=template&id=2d0ed522&"
import script from "./CASEAssociatedItemTree.vue?vue&type=script&lang=js&"
export * from "./CASEAssociatedItemTree.vue?vue&type=script&lang=js&"
import style0 from "./CASEAssociatedItemTree.vue?vue&type=style&index=0&id=2d0ed522&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VIcon,VSpacer})
